<template>
  <div class="trainings-page">
    <app-page-header title="Treinamentos">
      <router-link
        :to="{ name: 'trainings.create' }"
        tag="button"
        type="button"
        v-app-button.icon-left
      >
        <b-icon size="is-small" icon="plus"></b-icon>Novo
      </router-link>
    </app-page-header>

    <trainings-table></trainings-table>
  </div>
</template>

<script>
import TrainingsTable from '@/components/Tables/TrainingsTable.vue';

export default {
  name: 'trainings-page',
  components: {
    TrainingsTable,
  },
};
</script>
